


if (window.DrDocWeb !== undefined) {
    console.warn('Lib Duplicate: DrDocWeb');
    //return;
}

//export default 
export default function DrDocWeb() {

};

/**
 * Convert a string to HTML entities
 */
String.prototype.toHtmlEntities = function () {
    return this.replace(/./gm, function (s) {
        // return "&#" + s.charCodeAt(0) + ";";
        return (s.match(/[a-z0-9\s]+/i)) ? s : "&#" + s.charCodeAt(0) + ";";
    });
};

/**
 * Create string from HTML entities
 */
String.fromHtmlEntities = function (string) {
    return (string + "").replace(/&#\d+;/gm, function (s) {
        return String.fromCharCode(s.match(/\d+/gm)[0]);
    })
};

String.prototype.contains = function (search, start) {
    'use strict';
    if (typeof start !== 'number') {
        start = 0;
    }

    if (start + search.length > this.length) {
        return false;
    } else {
        return this.indexOf(search, start) !== -1;
    }
};

String.prototype.hashCode = function () {
    var hash = 0,
        i, chr;
    if (this.length === 0) return hash;
    for (i = 0; i < this.length; i++) {
        chr = this.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};

console.log('DRDOCWEB INIT');

//module.exports = DrDocWeb
//export default DrDocWeb
//export { DrDocWeb };
window.DrDocWeb = DrDocWeb;

DrDocWeb.ServerHost = document.location.protocol + '//' + document.location.hostname;
DrDocWeb.ServerPort = document.location.port;
DrDocWeb.ServerBase = function () {
    return DrDocWeb.ServerHost + (!DrDocWeb.IsNullOrEmpty(DrDocWeb.ServerPort) ? ':' + DrDocWeb.ServerPort : '');
};
DrDocWeb.DefaultError = function (error) {
    console.warn(error);
    DrDocWeb.ModalError('Fehler!');
};
DrDocWeb.IsMobile = function () {
    return window.innerWidth < window.innerHeight && window.innerWidth < 560; //850;
    //return window.innerWidth < 800;
};
DrDocWeb.UrlEncode = function (val) {
    return encodeURIComponent(typeof val === "object" ? DrDocWeb.ObjectToJson(val) : val);
}
DrDocWeb.ObjectToQueryStr = function (obj) {
    if (obj === null || obj === undefined)
        return '';
    if (typeof obj === 'string')
        return obj;
    var strArr = [];
    for (var p in obj) {
        if (obj.hasOwnProperty(p)) {
            var v = obj[p];
            /*strArr.push(encodeURIComponent(p) + "=" + encodeURIComponent(typeof v == "object" ? JSON.stringify(JsonResolve(v), function(key, value)
            {
                // => typeof Dataset
                // IDataset / Dataset.IsModel(value): $ModelType, $ClassName, Dataset
                if (key == 'ModelConfig' || key == 'ModelInfos' || key == 'Dataset') return;
                else return value;
            }) : v));*/
            strArr.push(DrDocWeb.UrlEncode(p) + "=" + DrDocWeb.UrlEncode(v));
        }
    }
    var str = strArr.join("&");
    //return (str.length == 0 ? '' : '?' + str);
    return str;
};
DrDocWeb.QueryStrToObject = function (str) {
    let obj = {};
    if (str === null || str === undefined) {
        return obj;
        //return undefined;
    }

    if (str.substring(0, 1) === '?') {
        str = str.substring(1);
    }
    let arr = str.split('&');
    for (var i in arr) {
        let kvp = arr[i].split('=');
        if (kvp !== undefined && kvp.length === 2) {
            obj[decodeURIComponent(kvp[0])] = decodeURIComponent(kvp[1]);
        }
    }
    return obj;
};
DrDocWeb.GetDataToObject = function () {
    return DrDocWeb.QueryStrToObject(window.location.search);
};
/*DrDocWeb.ArrayEquals = function(a, b) {
  return Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((val, index) => val === b[index]);
};*/
// Sind alle arr1 in arr2 enthalten?
DrDocWeb.ArrayEquals = function (arr1, arr2, caseSensitive) {
    if ((arr1 === undefined || arr1 === null || arr1.length == 0) && (arr2 === undefined || arr2 === null || arr2.length == 0)) {
        return true;
    }

    for (let elem1 of arr1) {
        if (elem1 === undefined || elem1 === null || elem1.length == 0)
            continue;
        //console.log('elem1', elem1);
        let found = false;
        for (let elem2 of arr2) {
            if (elem2 === undefined || elem2 === null || elem2.length == 0)
                continue;

            if ((caseSensitive && elem2 === elem1) || (!caseSensitive && elem2.toLowerCase() === elem1.toLowerCase())) {
                found = true;
                break;
            }
        }
        if (!found)
            return false;
    }
    //console.log('ArrayEquals', arr1, ' === ', arr2);
    return true;
};
/*DrDocWeb.ArrayEquals = function(arr1, arr2, caseSensitive)
{
    if ((arr1 === undefined || arr1 === null || arr1.length == 0) && (arr2 === undefined || arr2 === null || arr2.length == 0))
    {
        return true;
    }
    	
    for (let i in arr1)
    {
        if ((caseSensitive && arr1[i] !== arr2[i]) || (!caseSensitive && arr1[i].toLowerCase() !== arr2[i].toLowerCase()))
            return false;
    }
        
    //console.log('ArrayEquals', arr1, ' === ', arr2);
    return true;
};*/

DrDocWeb.GetArrayItemWhere = function (data, propName, propValue) {
    let i = DrDocWeb.GetArrayItemIndexWhere(data, propName, propValue);
    if (i >= 0) {
        return data[i];
    }
    return null;
};
DrDocWeb.GetArrayItemIndexWhere = function (data, propName, propValue) {
    for (var i = 0; i < data.length; i++) {
        if (typeof propName === 'function') {
            if (propName(data[i]) === true)
                return i;
        }
        else {
            if (data[i][propName] == propValue)
                return i;
        }
    }
    return -1;
};
DrDocWeb.ObjGetKeys = function (obj) {
    let ret = [];
    if (obj != null && obj != undefined) {
        for (let x in obj) {
            ret.push(x);
        }
        return ret;
    }
};

DrDocWeb.FormToObject = function (formName, splitter) {
    let form = null;
    if (typeof formName === 'string')
        form = document.forms[formName];
    else
        form = formName;

    if (form === undefined)
        return undefined;

    if (splitter === undefined || splitter === null)
        splitter = String.fromCharCode(1);
    if (typeof splitter === 'number')
        splitter = String.fromCharCode(splitter);

    let data = {};
    // $(form).serializeArray();
    for (let i = 0; i < form.elements.length; i++) {
        let form_elem = form.elements[i];
        //if (form_elem.value !== undefined)

        let name = form_elem.name;
        if (!DrDocWeb.IsNullOrEmpty(name)) {
            //if (pre !== undefined)
            //{
            //    name = pre + name;
            //}

            // Wenn ein Element checkable ist, dann nur den aktiven Wert setzen.
            let type = form_elem.getAttribute('type');
            if (type != undefined && type != null)
                type = type.toLowerCase();
            let isCheckable = type === 'select' || type === 'radio' || type === 'checkbox';
            //console.log('Form: ', name, type, isCheckable);

            //if (!isCheckable || type === 'checkbox' || (isCheckable && form_elem.checked === true))
            //if (!isCheckable || (type === 'checkbox' || form_elem.getAttribute('data-has-changed') == 'true'))
            //{
            let val = '';
            if (form_elem.value !== undefined && form_elem.value !== null) {
                if (isCheckable)
                    val = form_elem.checked === true ? form_elem.value : '';
                else
                    val = form_elem.value;
            }

            // 
            /*if (val == '' && type === 'checkbox' && form_elem.getAttribute('data-has-changed') == 'true')
            {
                val = '!' + form_elem.value;
            }*/
            if (DrDocWeb.IsNullOrEmpty(val))
                val = '';

            if (DrDocWeb.IsNullOrEmpty(val) && form_elem.getAttribute('trim') == 'true') {
                continue;
            }

            if (DrDocWeb.IsNullOrEmpty(val) && isCheckable) {
                continue;
            }

            // Falls ein Wert bereits vorhanden ist, dann anfügen.
            if (data[name] !== undefined && data[name] !== null) {
                if (typeof splitter === 'function')
                    data[name] = splitter(name, data[name], val);
                else if (splitter === 'array')
                    data[name].push(val);
                else
                    data[name] = data[name] + splitter + val;
            }
            else {
                if (splitter === 'array')
                    data[name] = [val];
                else
                    data[name] = val;
            }
            //}
        }
        else {
            //if (form_elem.tagName != 'button')
            //console.warn('Form: ELement hat kein Namen-Tttribute!', form_elem);
        }
        continue;


    }

    // Am Ende leere Splitter trimmen

    if (typeof splitter !== 'function' && splitter !== 'array') {
        for (let fieldName in data) {
            let fieldValue = data[fieldName];
            if (fieldValue !== undefined && fieldValue !== null && typeof fieldValue === 'string') {
                //data[fieldName] = fieldValue.replace(/[\|]+$/, '');
                data[fieldName] = fieldValue.replace(new RegExp('[\\' + splitter + ']+$'), '');
            }
        }
    }

    //console.log('Form A', data);
    //console.log('Form B', form.elements);
    return data;
};
DrDocWeb.GetFormDataFromEvent = function (ev) {
    if (ev instanceof FormData)
        return ev;

    let hasFile = false;
    var formData = new FormData();

    if (ev.dataTransfer && ev.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        for (var i = 0; i < ev.dataTransfer.items.length; i++) {
            // If dropped items aren't files, reject them
            if (ev.dataTransfer.items[i].kind === 'file') {
                var file = ev.dataTransfer.items[i].getAsFile();
                //console.log('... file[' + i + '].name = ' + file.name);
                formData.append("file" + i, file);
                hasFile = true;
            }
        }
    }
    else if (ev.dataTransfer && ev.dataTransfer.files) {
        // Use DataTransfer interface to access the file(s)
        for (var i = 0; i < ev.dataTransfer.files.length; i++) {
            //console.log('... file[' + i + '].name = ' + ev.dataTransfer.files[i].name);
            formData.append("file" + i, ev.dataTransfer.files[i]);
            hasFile = true;
        }
    }
    else if (ev.target && ev.target.files) {
        for (var i = 0; i < ev.target.files.length; i++) {
            formData.append("file" + i, ev.target.files[i]);
            hasFile = true;
        }
    }
    else if (ev.files) {
        for (var i = 0; i < ev.files.length; i++) {
            formData.append("file" + i, ev.files[i]);
            hasFile = true;
        }
    }

    if (hasFile)
        return formData;
    else
        return false;
};
// Holt das nächste Form, welches kein Child von einem Element mit dem Attribut "data-form-ignore" ist.
DrDocWeb.GetClosestForm = function (sourceElement) {
    //formData = document.querySelector('form [' + attr_name + '="' + DrDocWeb.SelectorAttributeEncode(nodeId) + '"]');
    let result = null;
    if (sourceElement !== undefined && sourceElement !== null && sourceElement.tagName != undefined && sourceElement.tagName.toLowerCase() == 'form')
        result = sourceElement;
    else
        result = DrDocWeb.GetElement(sourceElement, 'form:not([data-form-ignore] *)');
    //result = DrDocWeb.GetElement(sourceElement, 'form:has(:not([data-ignore]))');
    //result = DrDocWeb.GetElement(sourceElement, 'form:not(:has([data-ignore]))');
    return result;
};
DrDocWeb.ClosestFormToObject = function (sourceElement, splitter) {
    //formData = document.querySelector('form [' + attr_name + '="' + DrDocWeb.SelectorAttributeEncode(nodeId) + '"]');
    let result = DrDocWeb.GetClosestForm(sourceElement);
    if (result !== undefined && result !== null) {
        return DrDocWeb.FormToObject(result, splitter);
    }
    return undefined;
};
DrDocWeb.ClearClosestForm = function (sourceElement) {
    let form = DrDocWeb.GetClosestForm(sourceElement);
    if (form !== undefined && form !== null) {

        for (let i = 0; i < form.elements.length; i++) {
            let form_elem = form.elements[i];

            let name = form_elem.name;
            if (!DrDocWeb.IsNullOrEmpty(name)) {

                // Wenn ein Element checkable ist, dann nur den aktiven Wert setzen.
                let type = form_elem.getAttribute('type');
                if (type != undefined && type != null)
                    type = type.toLowerCase();
                let isCheckable = type === 'select' || type === 'radio' || type === 'checkbox';

                let val = '';
                if (form_elem.value !== undefined && form_elem.value !== null) {
                    if (isCheckable)
                        form_elem.checked = null;
                    else
                        form_elem.value = '';
                }
            }
        }
    }
};
/*DrDocWeb._ClosestFormToObject = function(sourceElement, splitter)
{
    let result = undefined;
    if (sourceElement.nodeName !== undefined && sourceElement.nodeName.toLowerCase() === 'form')
        result = sourceElement;
    else
    {
        result = $(sourceElement).parents('form')[0];
        if (result === undefined || result === null)
        {
            result = $(sourceElement).children('form')[0];
        }
    }
    if (result !== undefined && result !== null)
    {
        return DrDocWeb.FormToObject(result, splitter);
    }
    return undefined;
};*/
DrDocWeb.JsonToObjectWalker = function (parentObj, parentProp, refObjList) {
    let obj = parentObj[parentProp];
    for (var prop in obj) {
        let value = obj[prop];
        if (prop === '$id') {
            refObjList[value] = obj;
            delete obj['$id'];
        }
        else if (prop === '$values') {
            DrDocWeb.JsonToObjectWalker(obj, prop, refObjList);
            parentObj[parentProp] = value;
        }
        else if (prop === '$ref') {
            parentObj[parentProp] = refObjList[value];
        }
        else if (typeof value === 'object') {
            DrDocWeb.JsonToObjectWalker(obj, prop, refObjList);
        }
    }
};
DrDocWeb.JsonToObject = function (text) {
    if (text == null || text == undefined)
        return {};
    if (typeof text === 'object')
        return text;
    if (typeof text !== 'string') {
        console.log('DrDocWeb.JsonToObject: Bad format: ', text);
        return text;
    }
    var obj = { _root: JSON.parse(text) };
    var refObjList = {};
    DrDocWeb.JsonToObjectWalker(obj, '_root', refObjList);
    return obj._root;
};
DrDocWeb.ObjectToJson = function (obj) {
    if (obj == undefined || obj == null)
        return '';
    return JSON.stringify(obj);
};
DrDocWeb.CloneCopy = function (obj) {
    if (obj == undefined || obj == null)
        return obj;

    if (typeof obj === 'string' || typeof obj === 'number')
        return obj;

    if (Array.isArray(obj)) {
        return obj.slice(0);
    }

    if (typeof obj === 'object') {
        var arrTmp = {};
        Object.assign(arrTmp, obj);
        return arrTmp;
    }

    console.warn('DrDocWeb.CloneCopy: unknown obj type: ', typeof obj, obj);
    return obj;
};
DrDocWeb.CloneCopyTo = function (src, dst, ignorePropsArr) {
    for (var i in src) {
        if (ignorePropsArr == undefined || ignorePropsArr == null || ignorePropsArr.indexOf(i) === -1) {
            dst[i] = src[i];
        }
    }
};
DrDocWeb.GetRequestUrl = function (url, getData) {
    var requestUrl = DrDocWeb.ServerBase();

    // hat die "url" schon einen Hostnamen?
    // => dann setzen
    if (url !== null && url !== undefined) {
        if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0)
            requestUrl = url;
        else if (url.indexOf(requestUrl) === 0)
            requestUrl = url;
        else {
            if (url.indexOf('/') === 0)
                requestUrl += url;
            else
                requestUrl += '/' + url;
        }
    }

    // GET Parameter in URL übernehmen
    if (getData !== null && getData !== undefined) {
        requestUrl += (requestUrl.indexOf('?') === -1) ? '?' : '&';
        requestUrl += DrDocWeb.ObjectToQueryStr(getData);
    }

    return requestUrl;
};

DrDocWeb.Send = function (method, url, getData, postData, parseAs, sendAs, cookie, retAsync) {
    const promiseFn = function (resolve, reject) {
        //console.log('DrDocWeb.Send', method, url, getData, postData, parseAs, sendAs);
        try {
            var requestUrl = DrDocWeb.GetRequestUrl(url, getData);
            var request = new XMLHttpRequest();
            //try {

            const openRequestFn = function () {
                // Asynchron
                request.open(method, requestUrl, retAsync === true || retAsync === undefined);

                // Synchron
                //request.open(method, requestUrl, false);

                if (!DrDocWeb.IsNullOrEmpty(cookie)) {
                    request.withCredentials = true;
                    //request.setRequestHeader('Access-Control-Allow-Origin', '*');
                    //request.setRequestHeader('Access-Control-Allow-Headers', 'Cookie');
                    request.setRequestHeader('Cookie', cookie);
                    //console.log('DrDocWeb.Send ('+requestUrl+'): Cookie: ' + cookie);
                }
            };

            var processResponse = function (responseObj) {
                if (parseAs !== undefined && parseAs !== null && (parseAs.toLowerCase() == 'json' || parseAs.toLowerCase() == 'text/json' || parseAs.toLowerCase() == 'application/json'))
                    return DrDocWeb.JsonToObject(responseObj.responseText); //JSON.parse(event.target.responseText));
                else
                    return responseObj.responseText;
            };

            if (postData !== undefined && !(postData instanceof FormData)) {
                // postData instanceof FormData ? 'multipart/form-data; boundary=---------------------------jhdaddsdsfuifdsoufdsohhfdosisfdifsdohifdhfsodia' : 
                //request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            }
            //request.setRequestHeader('Access-Control-Allow-Origin', '*');
            /*request.setRequestHeader('Referer', null);
            request.setRequestHeader('Cookie', null);
            request.setRequestHeader('Host', null);
            request.setRequestHeader('Origin', null);
            request.setRequestHeader('User-Agent', null);
    
            request.removeRequestHeader('Referer');
            request.removeRequestHeader('Cookie');
            request.removeRequestHeader('Host');
            request.removeRequestHeader('Origin');
            request.removeRequestHeader('User-Agent');*/

            if (retAsync === true || retAsync === undefined) {
                //console.log('DrDocWeb.Send loading... ', event, method, url, getData, postData, parseAs, sendAs);
                if (resolve !== undefined && resolve !== null) {
                    request.addEventListener('load', function (event) {
                        //console.log('DrDocWeb.Send.onLoad', event, method, url, getData, postData, parseAs, sendAs);
                        //console.log('reponse', event);

                        if (reject !== undefined && reject !== null && event.target.status >= 400) {
                            console.log('DrDocWeb.Send.onLoad.catch status ', event.target.status);
                            reject(processResponse(event.target));
                        }
                        else {
                            resolve(processResponse(event.target));
                        }
                    });
                }
                if (reject !== undefined && reject !== null) {
                    request.addEventListener('timeout', reject);
                    request.addEventListener('error', reject);
                    request.addEventListener('abort', reject);
                }
            }

            // POST Parameter senden
            if (postData === undefined) {
                openRequestFn();
                request.send();
            }
            else if (postData instanceof FormData || sendAs == 'form') {

                // Progress-Bar
                /*
                let progressBarId = 'progress-' + DrDocWeb.RandomChars(12);
                let progressBarHtml = `
                <div id="${progressBarId}" class="progress" role="progressbar" aria-label="Document File Upload" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
  <div id="${progressBarId}-bar" class="progress-bar progress-bar-striped progress-bar-animated" style="width: 0%;"></div>
</div>
                `;
                let progressBarModal = DrDocWeb.ModalSecondary('Upload', progressBarHtml);

                let progressbarOnChange = function (e) {
                    //console.log('Upload Progress (e): ', e);
                    const percentComplete = e ? ((e.loaded / e.total) * 100) : 0;
                    //if (e.lengthComputable) {
                    //console.log('Upload Progress: ', percentComplete);
                    document.getElementById(progressBarId + '-bar').style.width = percentComplete + '%';
                    let progressBarElem = document.getElementById(progressBarId);
                    progressBarElem.setAttribute('aria-valuenow', percentComplete);
                    //}
                };
                progressbarOnChange();
                request.addEventListener('progress', progressbarOnChange);
                if (request.upload !== undefined)
                    request.upload.onprogress = progressbarOnChange;
                request.onprogress = progressbarOnChange;
                let progressBarCloseFn = function () {
                    if (progressBarModal != undefined && progressBarModal != null)
                        progressBarModal.close();
                };*/
                if (DrDocWeb.ModalProgress != undefined)
                {
                    let progressBarModal = DrDocWeb.ModalProgress('Document File Upload..');
                    
                    progressBarModal.setPercentComplete(0);

                    let progressbarOnChange = function (e) {
                        //console.log('Upload Progress (e): ', e);
                        const percentComplete = e ? ((e.loaded / e.total) * 100) : 0;
                        progressBarModal.setPercentComplete(percentComplete);
                    };
                    request.addEventListener('progress', progressbarOnChange);
                    if (request.upload !== undefined)
                        request.upload.onprogress = progressbarOnChange;
                    request.onprogress = progressbarOnChange;
                    let progressBarCloseFn = function () {
                        if (progressBarModal != undefined && progressBarModal != null)
                            progressBarModal.close();
                    };

                    request.addEventListener('load', progressBarCloseFn);
                    request.addEventListener('timeout', progressBarCloseFn);
                    request.addEventListener('error', progressBarCloseFn);
                    request.addEventListener('abort', progressBarCloseFn);
                }

                openRequestFn();
                request.send(postData);
            }
            else if (sendAs == 'json' || sendAs == 'text/json' || sendAs == 'application/json') {
                openRequestFn();
                request.setRequestHeader('Content-Type', 'application/json');
                request.send(JSON.stringify(postData));
            }
            else {
                openRequestFn();
                request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                request.send(DrDocWeb.ObjectToQueryStr(postData));
            }

            if (retAsync === true || retAsync === undefined) {
                // Async
            }
            else {
                //Sync
                return processResponse(request);
            }
        }
        catch (err) {
            if (reject !== undefined && reject !== null) {
                console.log('DrDocWeb.Send.catch 1');
                reject(err);
            }
            else {
                console.log('DrDocWeb.Send.catch 2');
                console.error(err);
                throw err;
            }
        }
    };

    if (retAsync === true || retAsync === undefined) {
        //console.log('DrDocWeb.Send.Promise');
        return new Promise(promiseFn);
    }
    else {
        //console.log('DrDocWeb.Send.Sync');
        return promiseFn();
    }
};
DrDocWeb.SendGet = function (url, getData, parseAs) {
    return DrDocWeb.Send('GET', url, getData, undefined, parseAs);
};
DrDocWeb.SendPost = function (url, getData, postData, parseAs) {
    return DrDocWeb.Send('POST', url, getData, postData, parseAs);
};

DrDocWeb.RandomChars = function (length) {
    return DrDocWeb.Random(length, 'abcdefghijklmnopqrstuvwxyz');
};
DrDocWeb.Random = function (length, characters) {
    let result = '';
    if (length === undefined)
        length = 32;
    if (DrDocWeb.IsNullOrEmpty(characters))
        characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
};
// Checksum
DrDocWeb.ChecksumCyrb53 = function (str, seed = 0) {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for (let i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
    h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
    h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);

    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};

DrDocWeb.CheckRecursion = function () {
    // the name of the calling function 

    var fname = DrDocWeb.CheckRecursion.arguments.callee.caller.name;


    // obtain the stack trace ***not cross browser***
    // tested on Firefox

    var err = new Error();
    var stack = err.stack.split('\n');


    // returns true if the calling function appears more than once

    var i, n, cnt;
    n = stack.length;
    cnt = 0;
    for (i = 0; i < n; i++) {
        if (fname == stack[i].substring(0, stack[i].indexOf('@'))) {
            cnt++;
            if (cnt > 1) {
                return true;
            }
        }
    }

    return false;
};

DrDocWeb.Crud = function (getData) {
    return DrDocWeb.SendGet('/model/crud', getData, 'json');
};
DrDocWeb.CrudListen = function (callback) {
    /*if (callback != null)
    {
        callback(null, null);
    }*/

    // Dataset.GetData = function (url, paramsObj, successCallback, errorCallback, finallyCallback)
    DrDocWeb.SendGet('/node/de/test', { listener: 99 },
        (obj) => {
            //console.warn('MAIN Load', e.target.responseText);
            //console.warn('MAIN Load', e);
            //Vue.set(Dataset.Model[obj.$ModelType], Dataset.GetID(obj), obj);
            if (callback != null) {
                callback(obj, true);
            }
            //Dataset.ListenState = true;
            //Vue.set(Dataset, 'ListenState', true);
            DrDocWeb.CrudListen(callback);
        },
        (obj) => {
            //Dataset.ListenState = false;
            //Vue.set(Dataset, 'ListenState', false);
            // Bei Fehler, nach einigen Sekunden erneut versuchen.
            setTimeout(() => { DrDocWeb.CrudListen(callback); }, 1000);

            if (callback != null) {
                callback(null, false);
            }

            console.warn('MAIN Error', obj, callback, false);

            if (DrDocWeb.DefaultError != null)
                DrDocWeb.DefaultError(obj);
        });
};

/*DrDocWeb.DataSelect = function(data, selector)
{
    if (data === undefined || data === null)
        return [];
    
    let ret_data = [];
    data.forEach(function(itm) {
        if (selector === undefined || selector(ret_data) === true)
        ret_data.push(itm);
    });
    return ret_data;
};*/

DrDocWeb.ParseBool = function (value) {
    if (value === undefined || value === null)
        return false;
    if (typeof value === 'bool' || typeof value === 'boolean')
        return value;
    if (typeof value === 'string')
        return value.toLocaleLowerCase() === 'true' || value === '1';
    return false;
};
DrDocWeb.ParseInt = function (value) {
    if (value === undefined || value === null || isNaN(value))
        return 0;
    if (typeof value === 'float')
        return value;
    if (typeof value === 'number')
        return value;
    //return +value;
    return parseFloat(value);
    // parseInt
};
DrDocWeb.ParseDateTime = function (dateStr) {
    dateStr = DrDocWeb.ToIsoDateTimeStr(dateStr);
    if (dateStr === undefined)
        return undefined;
    if (!isNaN(dateStr) && (typeof dateStr === 'date' || dateStr instanceof Date))
        return dateStr;
    return new Date(dateStr);
};
DrDocWeb.ToIsoDateTimeStr = function (dateStr) {
    if (DrDocWeb.IsNullOrEmpty(dateStr)) // === undefined || dateStr === null || dateStr.length === 0)
        return undefined;
    if (!isNaN(dateStr) && (typeof dateStr === 'date' || dateStr instanceof Date))
        return dateStr.toISOString();

    // toUTCString
    if (typeof dateStr === 'number') {
        //console.log('DrDocWeb.ToIsoDateTimeStr: typeof dateStr === number', dateStr, new Date(dateStr * 1000), new Date(dateStr * 1000), new Date(dateStr * 1000 * 100));
        return new Date(dateStr).toISOString();
    }

    if (typeof dateStr !== 'string') {
        console.warn('DrDocWeb.ToIsoDateTimeStr / typeof dateStr !== string / ', typeof dateStr, ' / ', dateStr);
        return undefined;
    }

    let dateTimeComponents = dateStr.split(' ');
    if (dateTimeComponents.length == 2) {
        let dateComponents = dateTimeComponents[0].split('.');
        let timeComponents = dateTimeComponents[1].split(':');
        if (dateComponents.length == 3 && timeComponents.length >= 2)
            return dateComponents[2] + '-' + dateComponents[1] + '-' + dateComponents[0] + 'T' + timeComponents[0] + ':' + timeComponents[0];
    }
    else if (dateTimeComponents.length == 1) {
        let dateComponents = dateTimeComponents[0].split('.');
        if (dateComponents.length == 3)
            return dateComponents[2] + '-' + dateComponents[1] + '-' + dateComponents[0];
        //return dateComponents[1];
    }
    //console.warn('DrDocWeb.ParseDateTime: bad date', dateStr, dateTimeComponents);
    return dateStr;
};
DrDocWeb.DateTimeAddMulti = function (dsDate, duration_total_str) {
    for (let dauer_str of duration_total_str.split(' ')) {
        if (DrDocWeb.IsNullOrEmpty(dauer_str) || dauer_str.length < 2)
            continue;
        let dauer_unit = dauer_str.substring(dauer_str.length - 1);
        let dauer_num = DrDocWeb.ParseInt(dauer_str.substring(0, dauer_str.length - 1));

        dsDate = DrDocWeb.DateTimeAdd(dsDate, dauer_num, dauer_unit);
    }
    return dsDate;
};
DrDocWeb.DateTimeAdd = function (dt, amount, dateType) {
    if (DrDocWeb.IsNullOrEmpty(dt)) {
        dt = new Date();
    }
    else if (typeof dt === 'date' || dt instanceof Date) {

    }
    else {
        dt = DrDocWeb.ParseDateTime(dt);
    }

    switch (dateType.toUpperCase()) {
        case 'T':
        case 'D':
        case 'DAY':
        case 'DAYS':
            return dt.setDate(dt.getDate() + amount) && dt;
        case 'W':
        case 'WEEK':
        case 'WEEKS':
            return dt.setDate(dt.getDate() + (7 * amount)) && dt;
        case 'M':
        case 'MONTH':
        case 'MONTHS':
            return dt.setMonth(dt.getMonth() + amount) && dt;
        case 'Y':
        case 'J':
        case 'YEAR':
        case 'YEARS':
            return dt.setFullYear(dt.getFullYear() + amount) && dt;
        default:
            console.warn('DrDocWeb.DateTimeAdd: bad date unit: ', dateType);
            break;
    }
};

DrDocWeb.EventFire = function (el, eventName, fn) {
    var doc = !el ? document : (el.ownerDocument || document);
    //console.log('Fire Event', eventName, el);
    if (!DrDocWeb.IsNullOrEmpty(eventName) && eventName.substring(0, 2) == 'on') {
        //console.log('DrDocWeb.EventFire: mod: ', eventName, ' -> ', eventName.substring(2));
        eventName = eventName.substring(2);
    }

    var evObj = null;
    if (document.createEvent) {
        evObj = doc.createEvent('Events'); // HTMLEvents
        // initEvent(type, bubbles, cancelable)
        evObj.initEvent(eventName, true, true); //false);
    }
    else {
        evObj = doc.createEventObject();
        evObj.eventType = eventName;
    }

    if (fn !== undefined && fn !== null && typeof fn === 'function') {
        try {
            fn(evObj);
        }
        catch (ex) {
            console.warn('DrDocWeb.EventFire: ', el, eventName, ex);
        }
    }

    if (document.createEvent) {
        doc.dispatchEvent(evObj);
    }
    else {
        //if (doc.fireEvent)
        //doc.fireEvent('on' + eventName);
        doc.fireEvent('on' + evObj.eventType, evObj);
    }

};

// --
// DOM

// Suche nach:
// - DrDocWeb.GetParentNode
// - DrDocWeb.FindChildElement
// - DrDocWeb.FindChildElements
// - DrDocWeb.SelectLastElementById
DrDocWeb.GetElement = function (sourceElement, selector, first) {
    if (sourceElement === undefined || sourceElement === null)
        sourceElement = document;
    try {
        if (typeof sourceElement === 'string')
            sourceElement = document.querySelectorAll(sourceElement);
    }
    catch {
        console.warn('DrDocWeb.GetElement: Bad sourceElement', sourceElement, selector);
        sourceElement = document;
    }

    if (!selector.contains(' ') && !selector.contains('-') && !selector.contains(':') && !selector.contains('[')) {
        //console.log('DrDocWeb.GetElement: is TagName: ', selector, sourceElement.tagName, sourceElement);
        if (!DrDocWeb.IsNullOrEmpty(sourceElement.tagName) && sourceElement.tagName.toLowerCase() == selector.toLowerCase()) {
            console.log('DrDocWeb.GetElement: sourceElement.tagName.toLowerCase() == selector.toLowerCase(): ', sourceElement);
            return sourceElement;
        }
    }

    if (!selector.contains(' ') && selector.indexOf('[') === 0 && selector.indexOf(']') === selector.length - 1) {
        let attrName = selector.substring(1, selector.length - 1);
        //console.log('DrDocWeb.GetElement: is Attribute: ', selector, sourceElement.tagName, attrName, sourceElement);
        if (sourceElement.hasAttribute(attrName)) {
            console.log('DrDocWeb.GetElement: Attr: ', attrName, sourceElement.getAttribute(attrName), sourceElement);
            return sourceElement;
        }
    }

    let result = (typeof sourceElement.querySelectorAll === 'function') ? sourceElement.querySelectorAll(selector) : null;
    if (result !== undefined && result !== null && result.length == 1) {
        //if (result.length > 1)
        //console.log('DrDocWeb.GetElement: Element wurde mehrfach gefunden! ', selector, sourceElement);
        return result[0];
    }

    let elems = DrDocWeb.GetElements(sourceElement, selector);
    if (elems === undefined || elems === null || elems.length == 0)
        return undefined;
    if (first === undefined && elems.length > 1) {
        console.warn('DrDocWeb.GetElement: Element wurde mehrfach gefunden! Selector: ', selector, 'Elements: ', elems, 'Source: ', sourceElement);
    }
    if (first === true || first === 1)
        return elems[0];
    if (first === -1)
        return elems[elems.length - 1];
    else //if (first === null)
        return elems[elems.length - 1];
};
DrDocWeb.GetElements = function (sourceElement, selector) {
    if (sourceElement === undefined || sourceElement === null)
        sourceElement = document;

    let result = null;
    result = DrDocWeb.GetChildElements(sourceElement, selector);
    if (result !== undefined && result !== null && result.length > 0) {
        return result;
    }

    result = DrDocWeb.GetParentElements(sourceElement, selector);
    if (result !== undefined && result !== null && result.length > 0) {
        return result;
    }
    return [];
};
DrDocWeb.GetParentElements = function (sourceElement, selector) {
    if (sourceElement === undefined || sourceElement === null)
        sourceElement = document;
    while (sourceElement !== undefined && sourceElement !== null) {
        let result = sourceElement.querySelectorAll(selector);
        if (result !== undefined && result !== null && result.length > 0) {
            return result;
            //return result;
        }
        sourceElement = sourceElement.parentNode;
    }
    return undefined;
};
DrDocWeb.GetChildElements = function (sourceElement, selector) {
    if (sourceElement === undefined || sourceElement === null)
        sourceElement = document;

    /*for (let i in sourceElement.childNodes)
    {

    }*/
    return sourceElement.querySelectorAll(selector);
};

/*DrDocWeb._GetParentNode = function(sourceElement, compare)
{
    if (compare === undefined || typeof compare !== 'function')
        return undefined;
    if (sourceElement === undefined)
        sourceElement = document;

    while (sourceElement !== undefined && sourceElement !== null)
    {
        let result = compare(sourceElement);
        if (result !== undefined && result !== null && result !== false)
        {
            return sourceElement;
            //return result;
        }
        sourceElement = sourceElement.parentNode;
    }
    return undefined;
};*/
/*DrDocWeb._SelectLastElementById = function(id)
{
    var elems = document.querySelectorAll('#' + id);
    if (elems === undefined)
    return undefined;
    return elems[elems.length-1];
};*/
DrDocWeb.FindChildElement = function (element, attr_name, attr_value, attr_comparer) {
    if (element === null || element === undefined || element.nodeName == '#text' || element.nodeName == '#comment')
        return undefined;
    if (attr_value === null || attr_value === undefined)
        return undefined;

    if (typeof element.getAttribute === 'function') {
        let elem_attr_val = element.getAttribute(attr_name);
        if (elem_attr_val !== undefined && elem_attr_val !== null && elem_attr_val.length > 0) {
            if (attr_comparer !== undefined && attr_comparer(elem_attr_val, attr_value) === true)
                return element;
            if (attr_comparer === undefined && elem_attr_val == attr_value)
                return element;
        }
    }

    for (var i in element.childNodes) {
        let sub = DrDocWeb.FindChildElement(element.childNodes[i], attr_name, attr_value, attr_comparer);
        if (sub != null)
            return sub;
    }
    return undefined;
};
DrDocWeb.FindChildElements = function (element, attr_name, attr_value, attr_comparer) {
    if (element === null || element === undefined || element.nodeName == '#text' || element.nodeName == '#comment')
        return undefined;
    if (attr_value === null || attr_value === undefined)
        return undefined;

    let list = [];

    if (typeof element.getAttribute === 'function') {
        let elem_attr_val = element.getAttribute(attr_name);
        if (elem_attr_val !== undefined && elem_attr_val !== null && elem_attr_val.length > 0) {
            if (attr_comparer !== undefined && attr_comparer(elem_attr_val, attr_value) === true)
                list = [element];
            if (attr_comparer === undefined && elem_attr_val == attr_value)
                list = [element];
        }
    }

    for (var i in element.childNodes) {
        let sub = DrDocWeb.FindChildElements(element.childNodes[i], attr_name, attr_value, attr_comparer);
        if (sub !== undefined && sub !== null && sub.length > 0) {
            //if (list === undefined)
            //    list = sub;
            //else
            //{
            //list.push(...sub);
            for (let sub_i in sub) {
                list.push(sub[sub_i]);
            }
            //}
        };
    }
    return list;
};

DrDocWeb.loadCSS = function (cssFilePath, cssId, initDoc) {
    if (!DrDocWeb.IsNullOrEmpty(cssId) && document.getElementById(cssId) != undefined)
        return;

    if (initDoc) {
        console.log(document.getElementsByTagName('head'));
        console.log(document.getElementsByTagName('body'));

        var head = document.getElementsByTagName('head')[0];

        if (head == null || head == undefined)
            return;

        {
            var meta = document.createElement('meta');
            meta.setAttribute('name', 'viewport');
            meta.setAttribute('content', 'width=device-width, initial-scale=1, shrink-to-fit=no');
            head.appendChild(meta);
        }

        {
            var meta = document.createElement('meta');
            meta.setAttribute('charset', 'utf-8');
            head.appendChild(meta);
        }
    }

    {
        var link = document.createElement('link');
        if (!DrDocWeb.IsNullOrEmpty(cssId))
            link.id = cssId;
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = cssFilePath;
        //link.media = 'all';
        head.appendChild(link);
    }
};

DrDocWeb.setInnerHTML = function (elm, html, callback) {
    var doc = (elm.ownerDocument || document);
    try {
        if (!DrDocWeb.IsNullOrEmpty(html) && html.indexOf('<') == -1 && html.indexOf('>') == -1) // && html.indexOf('\n') == -1)
            elm.innerText = html;
        else
            elm.innerHTML = html;
        Array.from(elm.querySelectorAll("script")).forEach(oldScript => {
            const newScript = doc.createElement("script");
            Array.from(oldScript.attributes)
                .forEach(attr => newScript.setAttribute(attr.name, attr.value));
            newScript.appendChild(doc.createTextNode(oldScript.innerHTML));
            if (callback != undefined) {
                newScript.onload = callback;
                newScript.onreadystatechange = function () {
                    if (this.readyState == 'complete') {
                        callback();
                    }
                }
            }
            oldScript.parentNode.replaceChild(newScript, oldScript);
        });
    }
    catch (ex) {
        console.warn('DrDocWeb.setInnerHTML: HTML konnte nicht geparst werden', html, elem, ex);
    }
};

DrDocWeb.IframeAutosize = function (iframe, selector, lastWidth, lastHeight, maxWidthStr, maxHeightStr) {
    if (iframe != undefined && iframe != null) {
        if (iframe.contentWindow != undefined && iframe.contentWindow != null && iframe.contentWindow.document != undefined && iframe.contentWindow.document != null) {
            //console.log('DrDocWeb.IframeAutosize: SetSize (1): ', iframe.contentWindow.document.readyState);

            // Erneut ausführen, bis das Dokument geladen ist
            if (iframe.contentWindow.document.readyState !== 'complete') {
                //console.log('DrDocWeb.IframeAutosize: iframe.contentWindow.document.readyState: ', iframe.contentWindow.document.readyState);
                setTimeout(function () {
                    DrDocWeb.IframeAutosize(iframe, selector, lastWidth, lastHeight, maxWidthStr, maxHeightStr);
                }, 200);
                //DrDocWeb.IframeAutosize(iframe, selector);
                return;
            }

            if (lastWidth == undefined || lastWidth === null) {
                iframe.width = '100%';
            }
            //iframe.height = '400px';
            //iframe.style.width = '100%';
            //iframe.style.width = '100px';
            //iframe.style.height = '1000px';

            let doc = iframe.contentWindow.document;

            let maxW = 0;
            let maxH = 0; //iframe.height;
            if (doc.body != undefined && doc.body != null) {
                if (doc.body.scrollWidth != undefined)
                    maxW = Math.max(maxW, doc.body.scrollWidth);
                if (doc.body.scrollHeight != undefined)
                    maxH = Math.max(maxH, doc.body.scrollHeight);
            }
            if (!DrDocWeb.IsNullOrEmpty(selector)) {
                let selectorElemArr = doc.querySelectorAll(selector);
                //console.log('DrDocWeb.IframeAutosize: selector: ', selector, selectorElem);
                if (selectorElemArr != undefined && selectorElemArr != null) {
                    selectorElemArr.forEach(function (selectorElem) {
                        if (selectorElem != undefined && selectorElem != null) {
                            //if (selectorElem.width != undefined)
                            //    maxW = Math.max(maxW, selectorElem.width);
                            if (selectorElem.scrollWidth != undefined)
                                maxW = Math.max(maxW, selectorElem.scrollWidth);
                            //if (selectorElem.height != undefined)
                            //    maxH = Math.max(maxH, selectorElem.height);
                            if (selectorElem.scrollHeight != undefined)
                                maxH = Math.max(maxH, selectorElem.scrollHeight);
                        }
                    });
                }
                //console.log('DrDocWeb.IframeAutosize: Size: ', maxW, ' x ', maxH);
            }
            if (doc.documentElement != undefined && doc.documentElement != null) {
                if (doc.documentElement.scrollWidth != undefined)
                    maxW = Math.max(maxW, doc.documentElement.scrollWidth);
                if (doc.documentElement.scrollHeight != undefined)
                    maxH = Math.max(maxH, doc.documentElement.scrollHeight);
            }
            /*if (iframe.contentWindow.width != undefined)
                maxW = Math.max(maxW, iframe.contentWindow.width);
            if (iframe.contentWindow.height != undefined)
                maxH = Math.max(maxH, iframe.contentWindow.height);*/

            //console.log('DrDocWeb.IframeAutosize: SetSize (2): ', iframe.src, maxH, doc.body.scrollHeight, doc.documentElement.scrollHeight, iframe.contentWindow.height); //, doc);

            /*if (maxH > 150) {
                //iframe.width = maxW + 'px';
                iframe.height = maxH + 'px';

                // Wenn auch Inhalte bereits geladen wurden, nur alle 5 Sek. Größe erneut anpassen
                setTimeout(function () {
                    DrDocWeb.IframeAutosize(iframe, selector, false);
                }, 5000);
            }
            else {
                // Wenn auch Inhalte noch nicht geladen wurden, alle 0,2 Sek. Größe erneut anpassen
                setTimeout(function () {
                    DrDocWeb.IframeAutosize(iframe, selector, false);
                }, 1000);
            }*/
            // Wenn auch Inhalte noch nicht geladen wurden, alle 0,2 Sek. Größe erneut anpassen
            setTimeout(function () {
                DrDocWeb.IframeAutosize(iframe, selector, maxW, maxH, maxWidthStr, maxHeightStr);
            }, 1000);

            //console.log('DrDocWeb.IframeAutosize: Size: Neu: ', maxW, ' x ', maxH, ' / alt: ', lastWidth, ' x ', lastHeight, ' / max: ', maxWidthStr, 'x', maxHeightStr);

            if (lastWidth == undefined || maxW > lastWidth + 150) {
                iframe.style.width = (maxW + 0) + 'px';
                if (!DrDocWeb.IsNullOrEmpty(maxWidthStr))
                    iframe.style.maxWidth = maxWidthStr;
                else
                    iframe.style.maxWidth = (maxW + 0) + 'px';
            }

            if (lastHeight == undefined || maxH > lastHeight + 150) {
                iframe.style.height = (maxH + 0) + 'px';
                if (!DrDocWeb.IsNullOrEmpty(maxHeightStr))
                    iframe.style.maxHeight = maxHeightStr;
                else
                    iframe.style.maxHeight = (maxH + 0) + 'px';
            }

            iframe.contentWindow.document.documentElement.style.overflow = 'hidden';
        }
        else {
            //console.log('DrDocWeb.IframeAutosize: Init (0): ', iframe.src);

            if (iframe._hasLoadEvent === true)
                return;
            iframe._hasLoadEvent = true;

            iframe.addEventListener('load', function (e) {
                //console.log('DrDocWeb.IframeAutosize: onLoad (1, root): ', iframe.src);

                DrDocWeb.IframeAutosize(iframe, selector, lastWidth, lastHeight, maxWidthStr, maxHeightStr);
            });
        }
    }
    else {
        //console.log('DrDocWeb.IframeAutosize: iframe == null');
    }
};

DrDocWeb.FindLeftWindowBoundry = function (wnd) {
    // In Internet Explorer window.screenLeft is the window's left boundry
    if (wnd.screenLeft) {
        return wnd.screenLeft;
    }

    // In Firefox window.screenX is the window's left boundry
    if (wnd.screenX)
        return wnd.screenX;

    return 0;
};
DrDocWeb.FindTopWindowBoundry = function (wnd) {
    // In Internet Explorer window.screenLeft is the window's left boundry
    if (wnd.screenTop) {
        return wnd.screenTop;
    }

    // In Firefox window.screenX is the window's left boundry
    if (wnd.screenY)
        return wnd.screenY;

    return 0;
}

// // Find Left Boundry of the Screen/Monitor
DrDocWeb.FindLeftScreenBoundry = function (wnd) {
    let left = DrDocWeb.FindLeftWindowBoundry(wnd);

    // Check if the window is off the primary monitor in a positive axis
    // X,Y                  X,Y                    S = Screen, W = Window
    // 0,0  ----------   1280,0  ----------
    //     |          |         |  ---     |
    //     |          |         | | W |    |
    //     |        S |         |  ---   S |
    //      ----------           ----------
    if (left > wnd.screen.width) {
        return left - (left - wnd.screen.width);
    }

    // Check if the window is off the primary monitor in a negative axis
    // X,Y                  X,Y                    S = Screen, W = Window
    // 0,0  ----------  -1280,0  ----------
    //     |          |         |  ---     |
    //     |          |         | | W |    |
    //     |        S |         |  ---   S |
    //      ----------           ----------
    // This only works in Firefox at the moment due to a bug in Internet Explorer opening new windows into a negative axis
    // However, you can move opened windows into a negative axis as a workaround
    if (left < 0 && left > (wnd.screen.width * -1)) {
        return (wnd.screen.width * -1);
    }

    // If neither of the above, the monitor is on the primary monitor whose's screen X should be 0
    return 0;
};

DrDocWeb.FindTopScreenBoundry = function (wnd) {
    let top = DrDocWeb.FindTopWindowBoundry(wnd);

    if (top > wnd.screen.height) {
        return top - (top - wnd.screen.height);
    }

    if (top < 0 && top > (wnd.screen.height * -1)) {
        return (wnd.screen.height * -1);
    }

    return 0;
};

DrDocWeb.ObjectForEachSorted = function (obj, action) {
    var keys = Object.keys(obj);
    var len = keys.length;

    keys.sort();

    for (i = 0; i < len; i++) {
        action(keys[i], obj[keys[i]]);
    }
};

// --
// Cookie Funktionen

DrDocWeb.SetCookie = function (cname, cvalue, exdays, path) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "Expires=" + d.toUTCString();
    //console.log('DrDocWeb.SetCookie(' + cname + ', ' + cvalue + ')', '\r\n', document.cookie);
    document.cookie = DrDocWeb.UrlEncode(cname) + "=" + DrDocWeb.UrlEncode(cvalue) + "; " + expires + "; Path=" + (!DrDocWeb.IsNullOrEmpty(path) ? path : '/') + "; SameSite=Lax;"; //SameSite=None;"; //samesite=lax;"; // SameSite=Lax;"; //SameSite=None; Secure";
};
DrDocWeb.GetCookie = function (cname, defaultValue) {
    let name = DrDocWeb.UrlEncode(cname) + "=";
    let ret = '';
    //let decodedCookie = document.cookie);
    if (document.cookie) //!DrDocWeb.IsNullOrEmpty())
    {
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                ret = decodeURIComponent(c.substring(name.length, c.length));
                //console.log('Cookie gefunden! ', name);
                break;
            }
            else {
                //console.log('Cookie NICHT gefunden! ', c, "\r\n", name);
            }
        }
        //console.log('Cookie... ', ca);
    }
    if (defaultValue === undefined)
        defaultValue = '';
    //console.log('DrDocWeb.GetCookie(' + cname + ', ' + defaultValue + ') = ', ret, '\r\n', document.cookie);
    return DrDocWeb.IsNullOrEmpty(ret) ? defaultValue : ret;
};
DrDocWeb.GetCookiePrefix = function (namePrefix) {
    //let name = DrDocWeb.UrlEncode(cname) + "=";

    let ret = [];

    //let decodedCookie = document.cookie);
    if (document.cookie) //!DrDocWeb.IsNullOrEmpty())
    {
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            let iOfEq = c.indexOf('=');
            if (iOfEq < 0)
                continue;
            let name = c.substring(0, iOfEq);
            if (name.indexOf(namePrefix) === 0) {
                let value = decodeURIComponent(c.substring(iOfEq + 1));
                console.log('DrDocWeb.GetCookiePrefix: Cookie gefunden! ', name, '|', value, '|');
                ret.push({
                    name: name,
                    value: value
                });
            }
            else {
                //console.log('Cookie NICHT gefunden! ', c, "\r\n", name);
            }
        }
        //console.log('Cookie... ', ca);
    }

    //console.log('DrDocWeb.GetCookie(' + cname + ', ' + defaultValue + ') = ', ret, '\r\n', document.cookie);
    return ret;
};

// ---
// Tree-View
// Root Element (UL): .tree
// Item Element (LI): .tree-item (ggf.: .tree-item-action)
// Item Element Container (UL): (ggf.: .tree-sub .tree-active)

DrDocWeb.TreeView = function () {
    //console.log('DrDocWeb.TreeView: init');

    var treeRootElemArr = document.querySelectorAll(".tree");
    if (treeRootElemArr != undefined && treeRootElemArr != null && treeRootElemArr.length > 0) {
        for (let i = 0; i < treeRootElemArr.length; i++) {
            DrDocWeb.TreeViewIntern(treeRootElemArr[i]);
        }
    }
};

DrDocWeb.TreeViewIntern = function (treeRootElem) {
    /*if (treeRootElem._tree_initialized === true)
    {
        console.log('DrDocWeb.TreeViewIntern (bereits initialisiert): ', treeRootElem);
        return;
    }
    treeRootElem._tree_initialized = true;
    console.log('DrDocWeb.TreeViewIntern: init', treeRootElem);*/

    var treeToggler = treeRootElem.querySelectorAll(".tree-item");
    //console.log('DrDocWeb.TreeViewIntern: .tree-item"*: ', treeToggler, '/', treeRootElem);

    if (treeToggler == undefined || treeToggler == null || treeToggler.length == 0) {
        treeToggler = treeRootElem.childNodes;
        //console.log('DrDocWeb.TreeViewIntern: >*: ', treeToggler, '/', treeRootElem);
        if (treeToggler != undefined && treeToggler != null && treeToggler.length > 0) {
            for (let i = 0; i < treeToggler.length; i++) {
                let liElem = treeToggler[i];
                if (!liElem.classList)
                    continue;
                liElem.classList.add('tree-item');

                let ulElem = liElem.querySelector("ul");
                if (ulElem) {
                    ulElem.classList.add('tree-sub');
                    //ulElem.classList.add('tree-active');

                    //DrDocWeb.TreeViewIntern(ulElem);
                }
            }
        }
    }

    treeToggler = treeRootElem.querySelectorAll(".tree-item");
    if (treeToggler != undefined && treeToggler != null && treeToggler.length > 0) {
        //console.log('DrDocWeb.TreeViewIntern: ', treeToggler);

        let updateTreeElem = function (liElem) {
            //liElem.classList.add("tree-caret-item");
            let ulElem = liElem.querySelector(".tree-sub");
            // wenn kein .tree-sub gefunden wurde, das erste "ul" finden
            if (ulElem == null || ulElem == undefined) {
                ulElem = liElem.querySelector("ul");
                if (ulElem)
                    ulElem.classList.add('tree-sub');
            }
            //if (ulElem == null || ulElem == undefined)
            //    ulElem = liElem.querySelector("*");
            if (ulElem) {
                if (ulElem.classList.contains('tree-active'))
                    liElem.classList.add("tree-caret-down");
                else
                    liElem.classList.remove("tree-caret-down");
            }
            else {
                //console.log('DrDocWeb.TreeViewIntern: updateTreeElem: tree elem kann ul sub nicht finden: updateTreeElem: ', liElem);
            }
        };
        for (let i = 0; i < treeToggler.length; i++) {
            let liElem = treeToggler[i];
            if (!liElem.classList)
                continue;
            updateTreeElem(liElem);
            //console.log('Tree, LI: ', liElem.firstChild, liElem.querySelector("*"), liElem.querySelector("span"), liElem.childNodes[0]);
            let onClick = function (e) {
                //let liElem = treeToggler[i]; //DrDocWeb.GetElement(liElem, 'li', true);

                // nur Event ausführen, wenn das OnClick Target passt: als das selbe Element oder ein direktes Child ist
                if (e.target !== liElem && e.target.parentNode !== liElem && !e.target.classList.contains('tree-item-action')) {
                    console.log('DrDocWeb.TreeViewIntern: onClick: e.target !== liElem, ', e, e.target, liElem);
                    return;
                }
                //console.log('DrDocWeb.TreeViewIntern: onClick: ', liElem);

                //let ulElem = DrDocWeb.GetElement(liElem, 'ul', true);
                let ulElem = liElem.querySelector(".tree-sub");
                /*if (ulElem == null || ulElem == undefined)
                {
                    ulElem = liElem.querySelector("ul");
                    if (ulElem)
                        ulElem.classList.add('tree-sub');
                }*/
                //if (ulElem == null || ulElem == undefined)
                //    ulElem = liElem.querySelector("*");
                if (ulElem) {
                    ulElem.classList.toggle("tree-active");
                }
                else {
                    //console.log('DrDocWeb.TreeViewIntern: onClick: tree elem kann ul sub nicht finden: ', e.target, liElem, liElem);
                }
                updateTreeElem(liElem);
            };
            //liElem.addEventListener("click", onClick);
            let actionElem = null;
            if (actionElem == null || actionElem == undefined)
                actionElem = liElem.querySelector(".tree-item-action");
            //if (actionElem == null || actionElem == undefined)
            //    actionElem = liElem.querySelector("li");
            //if (actionElem == null || actionElem == undefined)
            //    actionElem = liElem.querySelector("*");
            if (actionElem == null || actionElem == undefined) {
                // Trigger für Action darf nicht direkt das "li"-Element sein, sonst wird beim Click alle darunter sgeschlossen
                actionElem = liElem;
            }
            if (actionElem != undefined && actionElem != null) {
                if (actionElem.__tree_onClick != undefined) {
                    actionElem.removeEventListener("click", actionElem.__tree_onClick);
                    actionElem.removeEventListener("click", actionElem.__tree_onClick, true);
                    actionElem.removeEventListener("click", actionElem.__tree_onClick, false);
                }
                actionElem.__tree_onClick = onClick;
                actionElem.addEventListener("click", onClick, false);
            }
            else {
                console.log('DrDocWeb.TreeViewIntern: no action Element found: ', liElem, actionElem);
            }
        }
    }
};

// ---

DrDocWeb.SelectorAttributeEncode = function (str) {
    return str.replace(/["\\]/g, '\\$&');
};

// ---

DrDocWeb.DataGroup = function (data, selector_arr, emptyKeyValue, selector_i) {
    if (selector_i === undefined || selector_i < 0)
        selector_i = 0;
    if (selector_i >= selector_arr.length)
        return undefined;

    let ret_data = {};
    if (data !== undefined && data !== null) {
        //data.forEach(function (itm) {
        for (let data_key in data) {
            let itm = data[data_key];
            let key = selector_arr[selector_i](itm);
            let key_arr = null;

            // "itm" in "ret_data" einsortieren
            // Wenn key ein Array ist, für jedes Element einzeln einsortieren
            if (key != undefined && key != null && Array.isArray(key)) {
                if (key.length === 0)
                    key_arr = [''];
                else
                    key_arr = key;
                //console.log('DrDocWeb.DataGroup: arr: ', key_arr);
            }
            else {
                key_arr = [key];
            }

            for (let key_itm of key_arr) {
                // Default Key setzen, falls leer
                if (DrDocWeb.IsNullOrEmpty(key_itm) && !DrDocWeb.IsNullOrEmpty(emptyKeyValue)) {
                    key_itm = emptyKeyValue;
                }
                if (ret_data[key_itm] === undefined) {
                    ret_data[key_itm] = [];
                }
                //console.log('DrDocWeb.DataGroup: key_arr: ', key_itm, ': ', ret_data[key_itm]);

                if (ret_data[key_itm].indexOf(itm) === -1)
                    ret_data[key_itm].push(itm);
            }
        }
        if (selector_i + 1 < selector_arr.length) {
            for (let key in ret_data) {
                ret_data[key] = DrDocWeb.DataGroup(ret_data[key], selector_arr, emptyKeyValue, selector_i + 1);
            }
        }
    }
    //console.log('DrDocWeb.DataGroup: ', ret_data);
    return ret_data;
};

// ---

// KVP / Key-Value-Pair
// DrDocWeb.kvp_get(this, 'rootNamespace-1', 'search', 'field_')
// DrDocWeb.kvp_get(sourceElement, 'rootNamespace-1', 'search', 'field_', searchData, true);
// data-kvp-namespace="rootNamespace-1" data-kvp-key="Feld1" data-kvp-search="Test GmbH" data-kvp-value2="Test"
// => { 'field_Feld1': 'Test GmbH', field_value2: 'Test' }
DrDocWeb.KVP_ATTR = 'data-kvp';
DrDocWeb.KVP_ATTR_NAMESPACE = DrDocWeb.KVP_ATTR + '-namespace';
DrDocWeb.KVP_ATTR_KEY = DrDocWeb.KVP_ATTR + '-key';
DrDocWeb.KVP_ATTR_VALUE = DrDocWeb.KVP_ATTR + '-value';

DrDocWeb.kvp_get = function (sourceElement, rootNamespace, valueName, returnKeyPrefix, obj, strictParentHierarchy) {
    if (sourceElement == undefined || sourceElement == null)
        return;

    if (DrDocWeb.IsNullOrEmpty(valueName))
        valueName = 'value';
    if (DrDocWeb.IsNullOrEmpty(returnKeyPrefix))
        returnKeyPrefix = '';
    if (obj == undefined || obj == null)
        obj = {};

    //var rootElement = DrDocWeb.IsNullOrEmpty(selector) ? null : DrDocWeb.GetElement(sourceElement, selector);

    if (strictParentHierarchy) {
        DrDocWeb.kvp_getRecursiveInternal(sourceElement, rootNamespace, valueName, returnKeyPrefix, obj, strictParentHierarchy);
    }
    else {
        let elemList = document.querySelectorAll(`[${DrDocWeb.KVP_ATTR_NAMESPACE}="${DrDocWeb.SelectorAttributeEncode(rootNamespace)}"]`);
        if (elemList != undefined && elemList != null) {
            for (let elem of elemList) {
                DrDocWeb.kvp_getRecursiveInternal(elem, rootNamespace, valueName, returnKeyPrefix, obj, strictParentHierarchy);
            }
        }
    }

    //let elemNodeIgnoreList = [];
    //DrDocWeb.kvp_getInternal(sourceElement, rootNamespace, valueName, returnKeyPrefix, obj, strictHierarchy, searchParent, elemNodeIgnoreList);

    //console.log('DrDocWeb.kvp_get: root: ', obj);

    return obj;
}


/*DrDocWeb.kvp_getInternal = function (sourceElement, rootNamespace, valueName, returnKeyPrefix, obj, strictHierarchy, searchParent, elemNodeIgnoreList) {
    if (elemNodeIgnoreList.indexOf(sourceElement) >= 0)
        return;
    elemNodeIgnoreList.push(sourceElement);

    if (strictHierarchy) {
        // Strikt suchen
        DrDocWeb.kvp_getRecursiveInternal(sourceElement, rootNamespace, valueName, returnKeyPrefix, obj, strictHierarchy, searchParent, elemNodeIgnoreList);
    }
    else {
        let elemList = document.querySelectorAll(`[${DrDocWeb.KVP_ATTR_NAMESPACE}="${DrDocWeb.SelectorAttributeEncode(rootNamespace)}"]`);
        if (elemList != undefined && elemList != null) {
            for (let elem of elemList) {
                DrDocWeb.kvp_getRecursiveInternal(elem, rootNamespace, valueName, returnKeyPrefix, obj, strictHierarchy, false, elemNodeIgnoreList);
            }
        }
    }
}*/

DrDocWeb.kvp_getRecursiveInternal = function (sourceElement, rootNamespace, valueName, returnKeyPrefix, obj, strictParentHierarchy) {
    if (sourceElement.getAttribute !== undefined && typeof sourceElement.getAttribute === 'function') {
        let key = sourceElement.getAttribute(DrDocWeb.KVP_ATTR_KEY);

        // key vorhanden?
        if (!DrDocWeb.IsNullOrEmpty(key)) {
            let namespace = sourceElement.getAttribute(DrDocWeb.KVP_ATTR_NAMESPACE);

            // Namespace prüfen
            if ((DrDocWeb.IsNullOrEmpty(namespace) && DrDocWeb.IsNullOrEmpty(rootNamespace)) || namespace === rootNamespace) {
                // data-kvp-<valueName>="..."
                let value = sourceElement.getAttribute(DrDocWeb.KVP_ATTR + '-' + valueName.toLowerCase());
                if (!DrDocWeb.IsNullOrEmpty(value))
                    obj[returnKeyPrefix + key] = value;
            }
        }
    }

    //if (rootElement === sourceElement)
    //    return;

    if (strictParentHierarchy) {
        // Rekursive über Parent Node durchlaufen
        if (sourceElement.parentNode != null && sourceElement.parentNode != undefined) {
            DrDocWeb.kvp_getRecursiveInternal(sourceElement.parentNode, rootNamespace, valueName, returnKeyPrefix, obj, strictParentHierarchy);
        }
    }

}


// ---

// Drag and Drop
/*
+CSS:
[data-drag]
{
    cursor: pointer;
    user-select: none;
}
.drag-active[data-drag]
{
    border-color: $gray-500;
    border-width: 1px;
    border-style: solid;
}

+HTML:
<ul data-drag-value="value">
    <li data-drag="{{$_this.ID_Name}}" data-drag-value="apple" data-drag-action="copy,move,copyMove,link">Apples</li>
    <li data-drag="{{$_this.ID_Name}}">Oranges</li>
    <li data-drag="{{$_this.ID_Name}}">Bananas</li>
    <li data-drag="{{$_this.ID_Name}}">Strawberries</li>
</ul>
<div data-drag-action="drop">

DrDocWeb.dnd_init(elem)
DrDocWeb.dnd_getValue(elem)
*/

DrDocWeb.DND_ATTR = 'data-drag';
DrDocWeb.DND_ATTR_DROP = 'data-drop';
DrDocWeb.DND_ATTR_VALUE = DrDocWeb.DND_ATTR + '-value';
DrDocWeb.DND_ATTR_ACTION = DrDocWeb.DND_ATTR + '-action';
DrDocWeb.DND_ATTR_TRIGGER = DrDocWeb.DND_ATTR + '-trigger';
//DrDocWeb.DND_ATTR_IGNORE = DrDocWeb.DND_ATTR + '-ignore';
DrDocWeb.dnd_selected = {};

// Initialisiert alle Elemente mit dem Attribut data-drag="Name"
DrDocWeb.dnd_init = function (sourceElement) {
    let selector = `[${DrDocWeb.DND_ATTR}]`;
    let arr = DrDocWeb.GetElements(sourceElement, selector);
    //console.log('dnd_init: ', arr);
    for (let elem of arr) {
        dnd_initElement(elem);
    }

    /*for (let elem of DrDocWeb.GetElements(sourceElement, `[${DrDocWeb.DND_ATTR_IGNORE}]`)) {
        if (DrDocWeb.ParseBool(elem.getAttribute(DrDocWeb.DND_ATTR_IGNORE))) {
            elem.draggable = false;

            elem.addEventListener('dragstart', function (e) {
                console.log('DND: Disable: Start: ', e.targer, elem);
                e.preventDefault();
                return false;
            });
        }
    }*/
};


function dnd_getDragDropEvent(type, dataTransfer) {
    var dragDropEvent = new DragEvent(type);
    console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx', dataTransfer);
    Object.defineProperty(dragDropEvent.constructor.prototype, 'dataTransfer', dataTransfer);
    dragDropEvent['dataTransfer'] = dataTransfer;
    //console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',  dragDropEvent.dataTransfer.getData('Text'));
    console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx', dragDropEvent);
    return dragDropEvent;
};


// Drag n Drop Element initialisieren
function dnd_initElement(sourceElement, name) {
    if (sourceElement == undefined || sourceElement == null)
        return;

    // nur einmal initialisieren
    if (sourceElement._dnd_initialized === true)
        return;
    sourceElement._dnd_initialized = true;

    if (typeof sourceElement.getAttribute !== 'function')
        return;
    //if (DrDocWeb.IsNullOrEmpty(name))
    name = sourceElement.getAttribute(DrDocWeb.DND_ATTR);
    if (DrDocWeb.IsNullOrEmpty(name))
        return;

    // prüfen, ob das Draggable Element ein anderes Trigger Element hat
    let triggerElement = DrDocWeb.GetElement(sourceElement, `[${DrDocWeb.DND_ATTR_TRIGGER}="${DrDocWeb.SelectorAttributeEncode(name)}"]`, true);
    if (triggerElement != undefined && triggerElement != null) {
        //console.log('DND Init: User Trigger Element ', triggerElement, ' for source elem ', sourceElement);

        let dragAction = sourceElement.getAttribute(DrDocWeb.DND_ATTR_ACTION);
        //console.log('dnd_initElement: ', name);
        if (dragAction == 'false' || dragAction == 'none' || dragAction == 'drop' || dragAction == 'dropzone') {
            // Nur als Dropzone
            // Element nicht als Draggable markieren
            sourceElement.draggable = false;
            sourceElement.setAttribute('draggable', 'false');
        }
        else {

            // Element als Draggable markieren
            sourceElement.draggable = false;
            sourceElement.setAttribute('draggable', 'false');
            sourceElement.addEventListener('dragstart', function (e) {
                //console.log('dragstart: ', e.target, e);
                /*console.log('dragstart: ', DrDocWeb.DND_ATTR_IGNORE, ' / ', e.target.getAttribute(DrDocWeb.DND_ATTR_IGNORE), ' / ', e.target, e);
                if (DrDocWeb.ParseBool(e.target.getAttribute(DrDocWeb.DND_ATTR_IGNORE))) {
                    console.log('DRAG n Drop Cancel: ', e.target);
                    e.preventDefault();
                    return false;
                }*/
                dnd_dragStart(name, e);
            });

            // Element als Draggable markieren
            triggerElement.addEventListener('mousedown', function (e) {
                e.preventDefault();
                sourceElement.draggable = true;
                sourceElement.setAttribute('draggable', 'true');
                //setTimeout(function () {
                //    DrDocWeb.EventFire(sourceElement, 'mousedown');
                //    DrDocWeb.EventFire(sourceElement, 'dragstart');
                //}, 100);
                //DrDocWeb.EventFire(sourceElement, 'dragstart');


                /*var dragDataTransfer = {
                    data: {},
                    setData: function(type, value) { this.data[type] = value; },
                    getData: function(type) { return this.data[type] }
                 };

                 dragDataTransfer.setData('Text', 'foo....................');
                 var dragstaEv = dnd_getDragDropEvent('dragstart', dragDataTransfer);
                 sourceElement.dispatchEvent(dragstaEv);*/


                return false;
            });
        }
        sourceElement.addEventListener('dragover', function (e) {
            dnd_dragOver(name, e);
        });
        /*sourceElement.addEventListener('dragend', function (e) {
            dnd_dragEnd(name, e);
        });*/
        sourceElement.addEventListener('drop', function (e) {
            dnd_drop(name, e);
        });
    }
    else {
        let dragAction = sourceElement.getAttribute(DrDocWeb.DND_ATTR_ACTION);
        //console.log('dnd_initElement: ', name);
        if (dragAction == 'false' || dragAction == 'none' || dragAction == 'drop' || dragAction == 'dropzone') {
            // Nur als Dropzone
            // Element nicht als Draggable markieren
            sourceElement.draggable = false;
            sourceElement.setAttribute('draggable', 'false');
        }
        else {
            // Element als Draggable markieren
            sourceElement.draggable = true;
            sourceElement.setAttribute('draggable', 'true');
            sourceElement.addEventListener('dragstart', function (e) {
                /*console.log('dragstart: ', DrDocWeb.DND_ATTR_IGNORE, ' / ', e.target.getAttribute(DrDocWeb.DND_ATTR_IGNORE), ' / ', e.target, e);
                if (DrDocWeb.ParseBool(e.target.getAttribute(DrDocWeb.DND_ATTR_IGNORE))) {
                    console.log('DRAG n Drop Cancel: ', e.target);
                    e.preventDefault();
                    return false;
                }*/
                dnd_dragStart(name, e);
            });
        }
        sourceElement.addEventListener('dragover', function (e) {
            dnd_dragOver(name, e);
        });
        /*sourceElement.addEventListener('dragend', function (e) {
            dnd_dragEnd(name, e);
        });*/
        sourceElement.addEventListener('drop', function (e) {
            dnd_drop(name, e);
        });
    }
};

DrDocWeb.dnd_getElem = function (name, sourceElement, getContainer) {
    if (typeof sourceElement.hasAttribute === 'function') {
        if (sourceElement.hasAttribute(DrDocWeb.DND_ATTR) && name == sourceElement.getAttribute(DrDocWeb.DND_ATTR)) {
            /*if (getContainer === true) {
                let containerElement = DrDocWeb.GetElement(sourceElement, `[${DrDocWeb.DND_ATTR}-container="${DrDocWeb.SelectorAttributeEncode(name)}"]`, true);
                if (containerElement != undefined && containerElement != null) {
                    //console.log('DrDocWeb.dnd_getElem: Container, ', DrDocWeb.DND_ATTR, name, sourceElement, ' => ', containerElement);
                    return containerElement;
                }
            }*/

            //console.log('DrDocWeb.dnd_getElem: ', DrDocWeb.DND_ATTR, name, sourceElement);
            return sourceElement;
        }
        /*if (sourceElement.hasAttribute(DrDocWeb.DND_ATTR_DROP) && name == sourceElement.getAttribute(DrDocWeb.DND_ATTR_DROP)) {
            console.log('DrDocWeb.dnd_getElem: ', DrDocWeb.DND_ATTR_DROP, name, sourceElement);
            return sourceElement;
        }*/
    }
    let elemTmp = sourceElement.parentNode;
    if (elemTmp !== undefined && elemTmp !== null) {
        let parent = DrDocWeb.dnd_getElem(name, elemTmp, getContainer);
        if (parent !== undefined && parent !== null)
            return parent;
    }
    //let selector = `[${DrDocWeb.DND_ATTR}="${name}"]`;
    //return DrDocWeb.GetElement(sourceElement, selector, true);
    return undefined;
};
DrDocWeb.dnd_getValueElem = function (sourceElement) {
    if (sourceElement != undefined && sourceElement != null) {
        if (typeof sourceElement.hasAttribute === 'function' && sourceElement.hasAttribute(DrDocWeb.DND_ATTR_VALUE))
            return sourceElement;
        let elemTmp = sourceElement.parentNode;
        if (elemTmp !== undefined && elemTmp !== null) {
            let parent = DrDocWeb.dnd_getValueElem(elemTmp);
            if (parent !== undefined && parent !== null)
                return parent;
        }
    }
    return undefined;
};
DrDocWeb.dnd_getValue = function (sourceElement) {
    sourceElement = DrDocWeb.dnd_getValueElem(sourceElement);
    return sourceElement != undefined && sourceElement != null && typeof sourceElement.getAttribute === 'function' ? sourceElement.getAttribute(DrDocWeb.DND_ATTR_VALUE) : '';
};

// The user starts to drag an element
function dnd_dragStart(name, e) {
    if (!e)
        return;
    let sourceElement = DrDocWeb.dnd_getElem(name, e.target, true);
    let sourceElementTrigger = DrDocWeb.dnd_getElem(name, e.target, false);
    if (!sourceElement)
        return;

    /*
    // Drag n Drop Container und Trigger Element unterscheiden sich
    if (sourceElementTrigger !== sourceElement)
    {
        console.log('DND: Drag n Drop Container und Trigger Element unterscheiden sich: ', sourceElementTrigger, sourceElement);
        // sourceElement.draggable = true;
        // Container Element initialisieren
        dnd_initElement(sourceElement, name);
        e.preventDefault();
        // "dragstart" erneut für Container Element ausführen
        setTimeout(function(){
            DrDocWeb.EventFire(sourceElement, 'dragstart', function(e2){
        console.log('DND: Drag n Drop Container', ' / dragstart fired', e2);
            });
        }, 100);
        return false;
    }
    console.log('DND: Drag n Drop Start', sourceElementTrigger, sourceElement);
    */

    //let moveElement = DrDocWeb.GetElement(sourceElement, `[${DrDocWeb.DND_ATTR}-container="${DrDocWeb.SelectorAttributeEncode(name)}"]`, true);
    //if (moveElement != undefined && moveElement != null) {
    //    sourceElement = moveElement;
    //}

    sourceElement.classList.add('drag-active');
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations
    //console.log('dnd_dragStart: ', sourceElement, ' Prev: ', sourceElement.previousElementSibling, ' / Next: ', sourceElement.nextElementSibling);

    let actionStr = sourceElement.getAttribute(DrDocWeb.DND_ATTR_ACTION);
    if (!DrDocWeb.IsNullOrEmpty(actionStr)) {
        //console.log('dnd_dragStart: effectAllowed: ', actionStr);
        e.dataTransfer.effectAllowed = actionStr;
    }
    else {
        e.dataTransfer.effectAllowed = 'move';
    }
    e.dataTransfer.setData('text/plain', null);

    sourceElement.dnd = {
        sourceElement: sourceElement,
        sourceElementParent: sourceElement.parentNode,
        targetElement: null,
        targetElementParent: null,
        previousElementSibling: sourceElement.previousElementSibling,
        nextElementSibling: sourceElement.nextElementSibling,
        effectAllowed: e.dataTransfer.effectAllowed,
    };
    //sourceElement.style.cursor = 'move';
    //sourceElement.style.backgroundColor = 'green';

    DrDocWeb.dnd_selected[name] = sourceElement;
};

// A dragged element is over the drop target
// The ondragover event specifies where the dragged data can be dropped.
function dnd_dragOver(name, e) {
    if (DrDocWeb.dnd_selected[name] == null) {
        //console.log('dnd_dragOver: DrDocWeb.dnd_selected[name] == null: ', name);
        return;
    }
    e.preventDefault();
    /*let sourceElement = null;
    if (e.target._dnd_elem !== undefined) {
        sourceElement = e.target._dnd_elem;
    }
    else {
        sourceElement = DrDocWeb.dnd_getElem(name, e.target, true);
        e.target._dnd_elem = sourceElement;
    }*/

    let sourceElement = DrDocWeb.dnd_selected[name];
    let targetElement = DrDocWeb.dnd_getElem(name, e.target, true);
    if (sourceElement == null || sourceElement == undefined)
        return;
    // Effekt setzen für Cursor Symbol
    if (sourceElement.dnd != undefined && !DrDocWeb.IsNullOrEmpty(sourceElement.dnd.effectAllowed))
        e.dataTransfer.dropEffect = sourceElement.dnd.effectAllowed;

    // Element beim Drag and Drop einsortieren
    //if (DrDocWeb.IsNullOrEmpty(e.dataTransfer.effectAllowed) || e.dataTransfer.effectAllowed == 'move') {
    /*try {
        //console.log('dnd_dragOver: ', sourceElement, sourceElement.nextElementSibling);
        if (dnd_dragOver_isBeforeInternal(DrDocWeb.dnd_selected[name], sourceElement)) {
            sourceElement.parentNode.insertBefore(DrDocWeb.dnd_selected[name], sourceElement);
        } else {
            sourceElement.parentNode.insertBefore(DrDocWeb.dnd_selected[name], sourceElement.nextElementSibling);
        }
    } catch { }*/
    /*}
    else {
        //console.log('dnd_dragOver: effectAllowed: ', e.dataTransfer.effectAllowed);
        //var dt =  e.originalEvent.dataTransfer;
        //dt.dropEffect = e.dataTransfer.effectAllowed;
        //e.dataTransfer.dropEffect = e.dataTransfer.effectAllowed;
        //e.preventDefault();
    }*/

    // Ziel Parent Element setzen
    if (sourceElement.dnd != undefined) {
        if (targetElement != undefined && targetElement != null) {
            e.target.dnd = sourceElement.dnd;
            targetElement.dnd = sourceElement.dnd;
            sourceElement.dnd.targetElement = targetElement;
            if (targetElement.parentNode != undefined && targetElement.parentNode != null)
                sourceElement.dnd.targetElementParent = targetElement.parentNode;
        }
    }
};

function dnd_dragOver_isBeforeInternal(el1, el2) {
    if (!el1 || !el2)
        return false;
    let cur = null;
    if (el2.parentNode === el1.parentNode) {
        for (cur = el1.previousElementSibling; cur; cur = cur.previousElementSibling) {
            if (cur === el2)
                return true;
        }
    }
    return false;
};

// A dragged element is dropped on the target
// onDrop wird VOR onDragEnd aufgerufen
function dnd_drop(name, e) {
    if (DrDocWeb.dnd_selected[name] == null) {
        //console.log('dnd_drop: DrDocWeb.dnd_selected[name] == null: ', name, e.target);
        return;
    }
    //console.log('dnd_drop: e: ', name, DrDocWeb.dnd_selected[name], e);
    let sourceElement = DrDocWeb.dnd_selected[name];
    if (sourceElement == undefined || sourceElement == null) {
        //console.log('dnd_drop: sourceElement == null: ', name, e.target);
        return;
    }
    let targetElement = DrDocWeb.dnd_getElem(name, e.target, true);
    // Call preventDefault() to prevent the browser default handling of the data (default is open as link on drop)
    e.preventDefault();
    sourceElement.classList.remove('drag-active');

    // Ziel Parent Element setzen
    /*if (sourceElement.dnd != undefined)
    {
        sourceElement.dnd.targetElement = sourceElement;

        if (sourceElement.parentNode != undefined && sourceElement.parentNode != null)
            sourceElement.dnd.targetElementParent = sourceElement.parentNode;
    }*/

    if (sourceElement.dnd != undefined) {
        // In Target einsortieren
        if (!DrDocWeb.IsNullOrEmpty(sourceElement.dnd.effectAllowed) && sourceElement.dnd.effectAllowed == 'move') {
            try {
                if (dnd_dragOver_isBeforeInternal(DrDocWeb.dnd_selected[name], targetElement)) {
                    targetElement.parentNode.insertBefore(DrDocWeb.dnd_selected[name], targetElement);
                } else {
                    targetElement.parentNode.insertBefore(DrDocWeb.dnd_selected[name], targetElement.nextElementSibling);
                }
            } catch { }
        }

        // Ziel Parent Element setzen
        if (targetElement != undefined && targetElement != null) {
            e.target.dnd = sourceElement.dnd;
            targetElement.dnd = sourceElement.dnd;
            sourceElement.dnd.targetElement = targetElement;
            if (targetElement.parentNode != undefined && targetElement.parentNode != null)
                sourceElement.dnd.targetElementParent = targetElement.parentNode;
        }
    }

    //console.log('dnd_drop: ', name, ' / Target: ', e.target, ' / Source: ', sourceElement, ' / DND: ', sourceElement.dnd);
    //console.log('dnd_drop: ', name, ' / DND: ', sourceElement.dnd);

    // Source Element zurücksetzen
    //setTimeout(function () {
    DrDocWeb.dnd_selected[name] = null;
    //}, 5);
};

// onDragEnd wird NACH onDrop aufgerufen
function dnd_dragEnd(name, e) {
    if (DrDocWeb.dnd_selected[name] == null) {
        // console.log('dnd_dragEnd: DrDocWeb.dnd_selected[name] == null: ', name, e.target);
        return;
    }
    let sourceElement = DrDocWeb.dnd_getElem(name, e.target, true);
    if (!sourceElement)
        return;
    sourceElement.classList.remove('drag-active');
    //console.log('dnd_dragEnd: ', e, sourceElement, ' Prev: ', sourceElement.previousElementSibling, ' / Next: ', sourceElement.nextElementSibling);

    // Ziel Parent Element setzen
    if (sourceElement.dnd != undefined && sourceElement.parentNode != undefined && sourceElement.parentNode != null)
        sourceElement.dnd.targetElementParent = sourceElement.parentNode;
    // mit Timeout ausführen, damit "e.target" auf das Ziel weist
    //setTimeout(function(){
    // Element wieder an Quelle zurückschieben, wenn effectAllowed z.B. 'copy' ist
    // aber nur wenn: Element beim Drag and Drop einsortiert wurde
    /*if (sourceElement.dnd != undefined && !DrDocWeb.IsNullOrEmpty(sourceElement.dnd.effectAllowed) && sourceElement.dnd.effectAllowed != 'move') {
        //console.log('dnd_dragEnd: dnd 1 copy: ', sourceElement.dnd.effectAllowed, e.target===sourceElement, sourceElement.dnd.sourceElement===sourceElement, sourceElement);
        if (sourceElement.parentNode !== sourceElement.dnd.sourceElementParent) {
            sourceElement.parentNode.removeChild(sourceElement);
            sourceElement.dnd.sourceElementParent.appendChild(sourceElement);
        }
    }
    else {
        // move
        //console.log('dnd_dragEnd: dnd 2 move: ', e.target===sourceElement, sourceElement.dnd.sourceElement===sourceElement, sourceElement);
    }*/
    //}, 100);

    // Source Element zurücksetzen
    setTimeout(function () {
        DrDocWeb.dnd_selected[name] = null;
    }, 5);
};

// --

/*

            function mergeNode(node_new, node_old) {
                    if (node_new.childNodes === undefined && node_old.childNodes === undefined) {
                        //console.log('mergeNode undefined', node_new, node_old);
                        if (node_new.isSameNode(node_old))
                            console.log('mergeNode undefined', node_new, node_old);
                        return true;
                    }
    
                    if (node_new.childNodes.length != node_old.childNodes.length) {
                        console.log('mergeNode Length', node_new.childNodes.length, node_old.childNodes.length, node_new.childNodes, node_old.childNodes);
                        return false;
                    }
    
                    if (node_new.childNodes !== undefined && node_old.childNodes !== undefined) {
                        for (let i in node_new.childNodes) {
                            if (mergeNode(node_new.childNodes[i], node_old.childNodes[i]) === false)
                                return false;
                        }
                        return true;
                    }
    
                    return false;
                }
*/


// ---

// Math Helper

DrDocWeb.Math_Median = function (values) {
    if (values.length === 0) return 0;
    values.sort(function (a, b) {
        return a - b;
    });
    var half = Math.floor(values.length / 2);
    if (values.length % 2)
        return values[half];
    return (values[half - 1] + values[half]) / 2.0;
};

// --
// String Funktionen

DrDocWeb.IsNullOrEmpty = function (val) {
    return val === undefined || val === null || val === '' || (typeof val === 'number' && isNaN(val) === true);
};

// --
// String Extensions

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}
if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (searchString, position) {
        var subjectString = this.toString();
        if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
            position = subjectString.length;
        }
        position -= searchString.length;
        var lastIndex = subjectString.indexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
    };
}

// --

// Base64 Encode
DrDocWeb.b64EncodeUnicode = function (str) {
    // first we use encodeURIComponent to get percent-encoded UTF-8,
    // then we convert the percent encodings into raw bytes which
    // can be fed into btoa.
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
        return String.fromCharCode(parseInt(p1, 16));
        //return String.fromCharCode('0x' + p1);
    }));
};

/// Base64 Decode
DrDocWeb.b64DecodeUnicode = function (str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
};

// --

// JSON Funktionen

// JSON Parse
DrDocWeb.JsonParse = function (jsonStr) {
    if (jsonStr == null || jsonStr.length == 0)
        return null;
    return DrDocWeb.JsonRetrocycle(JSON.parse(jsonStr)); //event.target.responseText));
};

/**
 * Modified from Douglas Crockford's cycle.js (https://github.com/douglascrockford/JSON-js/blob/master/cycle.js).
 * Ported over to TypeScript, and modified to handle the reference schema that Json.NET uses.
 */

/* = {
    decycle: null,
    retrocycle: null
};*/
(function () {
    /**
     * The findReferences function walks recursively through an object graph built from a Json.NET string,
     * looking for $id properties. When it finds an object with that property, then it adds it to the catalog under that key.
     * @param obj The object from Json.NET
     * @param catalog The catalog of references that maintains state through the series of recursive calls.
     */
    function findReferences(obj, catalog) {
        if (obj && typeof obj === "object") {
            var id = obj.$id;
            if (typeof id === "string") {
                catalog[id] = obj;
            }
            if (Object.prototype.toString.apply(obj) === "[object Array]") {
                var i = void 0;
                for (i = 0; i < obj.length; i += 1) {
                    findReferences(obj[i], catalog);
                }
            } else {
                for (var name_1 in obj) {
                    if (obj.hasOwnProperty(name_1)) {
                        if (typeof obj[name_1] === "object") {
                            findReferences(obj[name_1], catalog);
                        }
                    }
                }
            }
        }
    }
    /**
     * The resolveReferences function walks through the object graph and replaces any references with the objects from the catalog.
     * @param obj The object from Json.NET
     * @param catalog The catalog of references that maintains state through the series of recursive calls.
     */
    function resolveReferences(obj, catalog) {
        if (obj && typeof obj === "object") {
            var i = void 0;
            var item = void 0;
            var id = void 0;
            if (Object.prototype.toString.apply(obj) === "[object Array]") {
                for (i = 0; i < obj.length; i += 1) {
                    item = obj[i];
                    if (item && typeof item === "object") {
                        id = item.$ref;
                        if (typeof id === "string") {
                            obj[i] = catalog[id];
                        } else {
                            obj[i] = resolveReferences(item, catalog);
                        }
                    }
                }
            } else if (obj.$values && Object.prototype.toString.apply(obj.$values) === "[object Array]") {
                var arr = new Array();
                for (i = 0; i < obj.$values.length; i += 1) {
                    item = obj.$values[i];
                    if (item && typeof item === "object") {
                        id = item.$ref;
                        if (typeof id === "string") {
                            arr[i] = catalog[id];
                        } else {
                            arr[i] = resolveReferences(item, catalog);
                        }
                    } else {
                        arr[i] = item;
                    }
                }
                obj = arr;
            } else {
                var name_2;
                for (name_2 in obj) {
                    if (obj.hasOwnProperty(name_2)) {
                        if (typeof obj[name_2] === "object") {
                            item = obj[name_2];
                            if (item) {
                                id = item.$ref;
                                if (typeof id === "string") {
                                    obj[name_2] = catalog[id];
                                } else {
                                    obj[name_2] = resolveReferences(item, catalog);
                                }
                            }
                        }
                    }
                }
            }
        }
        return obj;
    }
    /**
     * The createReferences function recurses through the object, producing the deep copy.
     * @param obj The object from Json.NET
     * @param catalog The catalog of references that maintains state through the series of recursive calls.
     */
    function getDecycledCopy(obj, catalog) {
        var i; // The loop counter
        var name; // Property name
        var nu; // The new object or array
        switch (typeof obj) {
            case "object":
                // typeof null === 'object', so get out if this value is not really an object.
                // Also get out if it is a weird builtin object.
                if (obj === null || obj instanceof Boolean || obj instanceof Date || obj instanceof Number || obj instanceof RegExp || obj instanceof String) {
                    return obj;
                }
                // If the value is an object or array, look to see if we have already
                // encountered it. If so, return a {$id:id} object. This is a hard way, O(n)
                // linear search that will get slower as the number of unique objects grows.
                // JavaScript really should have a decent dictionary or map class.
                for (i = 0; i < catalog.length; i += 1) {
                    if (catalog[i] === obj) {
                        return {
                            $ref: i.toString()
                        };
                    }
                }
                // Otherwise, accumulate the unique value and its id.
                obj.$id = catalog.length.toString();
                catalog.push(obj);
                // If it is an array, replicate the array.
                if (Object.prototype.toString.apply(obj) === "[object Array]") {
                    nu = [];
                    for (i = 0; i < obj.length; i += 1) {
                        nu[i] = getDecycledCopy(obj[i], catalog);
                    }
                } else {
                    // If it is an object, replicate the object.
                    nu = {};
                    for (name in obj) {
                        if (Object.prototype.hasOwnProperty.call(obj, name)) {
                            nu[name] = getDecycledCopy(obj[name], catalog);
                        }
                    }
                }
                return nu;
            case "number":
            case "string":
            case "boolean":
            default:
                return obj;
        }
    }
    /** Make a deep copy of an object or array, assuring that there is at most
        one instance of each object or array in the resulting structure. The
        duplicate references (which might be forming cycles) are replaced with
        an object of the form
          {$id: id}
        where the id is a simple string
    Modified from Douglas Crockford's cycle.js (https://github.com/douglascrockford/JSON-js/blob/master/cycle.js)
    Ported over to TypeScript, and modified to handle the reference schema that Json.NET uses.
 */
    function decycle(obj) {
        var catalog = []; // Keep a reference to each unique object or array
        var newObj = getDecycledCopy(obj, catalog);
        return newObj;
    }
    DrDocWeb.JsonDecycle = decycle;

    /** Restore an object that was reduced by decycle. Members whose values are objects of the form
         {$ref: id}
    are replaced with references to the value found by the id. This will
    restore cycles. The object will be mutated.

    So,
         var s = '{$id:1, members: [{$ref:"1"}]';
         return retrocycle(JSON.parse(s));
    produces an object containing an array which holds the object itself.
    */
    function retrocycle(obj) {
        var catalog = [];
        findReferences(obj, catalog);
        return resolveReferences(obj, catalog);
    }
    DrDocWeb.JsonRetrocycle = retrocycle;
})();

